import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <span className="text-2xl font-bold">
        <span className="text-[#2196F3]">Smarti</span>
        <span className="text-[#4CAF50]">Stat</span>
      </span>
      <span className="text-xs text-gray-600 ml-2 hidden sm:block">TAKE CONTROL SMARTLY</span>
    </div>
  );
};

export default Logo;